import React, {Component} from "react";
import "./style.css";
import {Button} from "reactstrap";
import {connect} from "react-redux";
import {getEnv} from "../../../../env";
import {
  ACTIONS,
  uploadImage,
  removeImage,
  updateImage,
  loadImages,
} from "../../../../01-actions/adminImages";
import Alert from "../../../../03-components/Alert/index";
import ImageDialog from "../../../ImageDialog/index";

class ImagesPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      imageDialog: false,
      imageDialogOptions: null,
      removeImageDialog: false,
    };
    props.loadImages();
  }

  render() {
    return (
      <div className="con-pages-admin-images">
        <div className="margin-bottom-15px margin-top-15px">
          <Button
            className={
              [ACTIONS.IMAGE_ADD_PROGRESS].indexOf(this.props.status) >= 0
                ? "progress-button"
                : ""
            }
            disabled={
              [ACTIONS.IMAGE_ADD_PROGRESS].indexOf(this.props.status) >= 0
            }
            onClick={() => {
              this.setState({
                imageDialog: true,
                imageDialogOptions: null,
              });
            }}
            color="primary"
            size="sm"
          >
            Add image
          </Button>
        </div>
        <div className="image-list">
          {this.props.images.map((image, index) => (
            <div className="image-item" key={index}>
              <div className="image-img">
                <img
                  alt="no-data"
                  src={
                    getEnv("S3_ASSETS_BUCKET") +
                    "/" +
                    image.path +
                    "?" +
                    Date.now()
                  }
                />
                <fieldset
                  disabled={
                    ([ACTIONS.IMAGE_REMOVE_PROGRESS].indexOf(
                      this.props.status,
                    ) >= 0 &&
                      this.props.imageRemove.type === image.type &&
                      this.props.imageRemove.name === image.name) ||
                    ([ACTIONS.IMAGE_EDIT_PROGRESS].indexOf(this.props.status) >=
                      0 &&
                      this.props.imageEdit.type === image.type &&
                      this.props.imageEdit.name === image.name)
                  }
                >
                  <div className="d-flex flex-column">
                    <Button
                      className={
                        [ACTIONS.IMAGE_REMOVE_PROGRESS].indexOf(
                          this.props.status,
                        ) >= 0 &&
                        this.props.imageRemove.type === image.type &&
                        this.props.imageRemove.name === image.name
                          ? "progress-button"
                          : ""
                      }
                      onClick={() => {
                        this.setState({
                          removeImageDialog: true,
                          removeImageInfo: {
                            type: image.type,
                            name: image.name,
                          },
                        });
                      }}
                      size="sm"
                      color="danger"
                    >
                      <i className="fas fa-trash" />
                    </Button>
                    <Button
                      className={
                        [ACTIONS.IMAGE_EDIT_PROGRESS].indexOf(
                          this.props.status,
                        ) >= 0 &&
                        this.props.imageEdit.type === image.type &&
                        this.props.imageEdit.name === image.name
                          ? "progress-button"
                          : ""
                      }
                      onClick={() => {
                        this.setState({
                          imageDialog: true,
                          imageDialogOptions: {
                            editMode: true,
                            value: image,
                          },
                        });
                      }}
                      size="sm"
                      color="primary"
                    >
                      <i className="fas fa-pencil-alt" />
                    </Button>
                  </div>
                </fieldset>
              </div>
              <div className="image-info">
                <div className="d-flex">
                  <span className="header-info">Type:</span>
                  <span>{image.type}</span>
                </div>
                <div className="d-flex">
                  <span className="header-info">Name:</span>
                  <span>{image.name}</span>
                </div>
                <div className="d-flex">
                  <span className="header-info">Data:</span>
                  <span>{image.data}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
        {this.state.imageDialog && (
          <ImageDialog
            options={this.state.imageDialogOptions}
            onOK={(options, values) => {
              this.setState({imageDialog: false});
              if (options && options.editMode) {
                this.props.updateImage(values);
              } else {
                this.props.uploadImage(values);
              }
            }}
            onClose={() => {
              this.setState({imageDialog: false, imageDialogOptions: null});
            }}
          />
        )}
        {this.state.removeImageDialog && (
          <Alert
            color="danger"
            header="Confirm"
            content="Do you want to remove this image?"
            cancelTitle="Cancel"
            okTitle="Remove"
            onOK={() => {
              this.props.removeImage({
                type: this.state.removeImageInfo.type,
                name: this.state.removeImageInfo.name,
              });
              this.setState({removeImageDialog: false});
            }}
            onClose={() => {
              this.setState({removeImageDialog: false});
            }}
          />
        )}
      </div>
    );
  }
}

const mapStateToProps = (store) => {
  return {
    status: store.adminImages.status,
    images: store.adminImages.images,
    imageRemove: store.adminImages.imageRemove,
    imageEdit: store.adminImages.imageEdit,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    uploadImage: (data) => {
      dispatch(uploadImage(data));
    },
    updateImage: (data) => {
      dispatch(updateImage(data));
    },
    loadImages: () => {
      dispatch(loadImages());
    },
    removeImage: (data) => {
      dispatch(removeImage(data));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ImagesPage);



// WEBPACK FOOTER //
// ./src/04-containers/_pages/Admin/Images/index.js